module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_EL-fd4ecc2df7fdcdcf47255b836f992250.svg";